import { createApp } from 'vue'
import privacy from '@/views/teeth/privacy.vue'
import '@/assets/css/index.css'
import i18n from '@/i18n/i18n'

createApp(privacy).use(i18n).mount('#app')
